export enum RoutingRuleScopeType {
  POLICY = 'POLICY',
  DISTRIBUTOR = 'DISTRIBUTOR',
  POLICY_DISTRIBUTOR = 'POLICY_DISTRIBUTOR',
}

export interface RoutingRuleModel {
  id: string;
  scopeType: RoutingRuleScopeType;
  policyId: string | null;
  distributorId: string | null;
  gatewayInstanceId: string;
  enabled: boolean;
  created: Date;
  modified: Date;
}

export type RoutingRuleRequest = Pick<
  RoutingRuleModel,
  'scopeType' | 'policyId' | 'distributorId' | 'gatewayInstanceId'
> & { enabled?: boolean };

export interface RoutingRulePolicyOption {
  id: string;
  title: string;
  policyNumber: string;
}

export interface RoutingRuleDistributorOption {
  id: string;
  name: string;
}

export interface RoutingRuleOptions {
  policies: RoutingRulePolicyOption[];
  distributors: RoutingRuleDistributorOption[];
}

/** Encodes a rule's scope without collisions when an identifier contains a separator. */
export function routingRuleScopeKey(
  scopeType: RoutingRuleScopeType,
  policyId: string | null,
  distributorId: string | null
): string {
  const part = (value: string) => `${value.length}:${value}`;

  switch (scopeType) {
    case RoutingRuleScopeType.POLICY:
      if (!policyId || distributorId !== null) break;
      return `P:${part(policyId)}`;
    case RoutingRuleScopeType.DISTRIBUTOR:
      if (!distributorId || policyId !== null) break;
      return `D:${part(distributorId)}`;
    case RoutingRuleScopeType.POLICY_DISTRIBUTOR:
      if (!policyId || !distributorId) break;
      return `PD:${part(policyId)}:${part(distributorId)}`;
  }

  throw new Error('Invalid payment gateway routing rule scope.');
}
